import React from "react";
import { ArrowUpRight } from "lucide-react";
import { brandName, footer, logoImage } from "../mock";

const FooterSection = () => {
  const isHome = window.location.pathname === "/";
  const resolveHref = (href) => {
    if (href.startsWith("#")) {
      return isHome ? href : `/${href}`;
    }
    return href;
  };
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#EDF1F8] px-6 pb-8 pt-10">
      <div className="relative mx-auto max-w-[1180px] overflow-hidden rounded-[34px] bg-[#5BA4FB] px-7 py-10 text-white shadow-[0_30px_90px_rgba(59,132,220,0.28)] md:px-14 md:py-14">
        {/* one calm highlight for depth — no busy shapes */}
        <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />

        <div className="relative grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <a href="/" className="inline-flex items-center gap-3">
              <img
                src={logoImage}
                alt="OpenPenguin logo"
                className="h-11 w-11 rounded-xl object-cover"
              />
              <span className="font-serif text-[28px] font-semibold italic leading-none tracking-tight">
                {brandName}
              </span>
            </a>
            <p className="mt-5 max-w-[300px] text-[15px] leading-7 text-white/75">
              {footer.line}
            </p>
            <div className="mt-7 flex flex-wrap gap-x-5 gap-y-2">
              {footer.socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="group inline-flex items-center gap-1.5 text-[15px] font-semibold text-white/80 transition-colors hover:text-white"
                >
                  {social.label}
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </a>
              ))}
            </div>
          </div>

          {/* Menü */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-white/55">
              Menü
            </h3>
            <nav className="mt-5 flex flex-col items-start gap-3.5">
              {footer.links.map((link) => (
                <a
                  key={link.label}
                  href={resolveHref(link.href)}
                  className="text-[16px] font-semibold text-white/80 transition-colors hover:text-white"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-white/55">
              {footer.contactTitle}
            </h3>
            <a
              href={`mailto:${footer.email}`}
              className="mt-5 block text-[20px] font-bold tracking-tight text-white transition-opacity hover:opacity-80 md:text-[22px]"
            >
              {footer.email}
            </a>
            <p className="mt-2 text-[15px] font-medium text-white/70">
              {footer.phone}
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="relative mt-12 flex flex-col gap-4 border-t border-white/20 pt-6 text-[14px] sm:flex-row sm:items-center sm:justify-between">
          <p className="font-medium text-white/70">
            © {year} {brandName} · Spalevic Consulting Kft.
          </p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {footer.legal.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="font-semibold text-white/75 transition-colors hover:text-white"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
